import {
  getBranches,
  createBranch,
  updateBranch,
  deleteBranch,
  createDepartment,
  updateDepartment,
  deleteDepartment,
} from '@/api';

const localState = {
  branches: [],
};

const actions = {
  async initBranchs({ commit, rootState }) {
    const projectId = rootState.project.currentProject.id;
    const res = await getBranches({ projectId });
    const { branches } = res.data;
    commit('setBranches', { branches });
  },
  // 一级分组部分
  async createBranch({ commit, rootState }, { name }) {
    const projectId = rootState.project.currentProject.id;
    const res = await createBranch({ projectId, name });
    const { code, branch, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('createBranch', { branch });
  },
  async updateBranch({ commit, rootState }, { id, name }) {
    const projectId = rootState.project.currentProject.id;
    const res = await updateBranch({ projectId, name, id });
    const { code, branch, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('updateBranch', { branch });
  },
  async deleteBranch({ commit, rootState }, { branch }) {
    const projectId = rootState.project.currentProject.id;
    const res = await deleteBranch({ projectId, id: branch.id });
    const { code, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('deleteBranch', { branch });
  },
  // 二级分组部分
  async createDepartment({ commit, rootState }, { branchId, name }) {
    const projectId = rootState.project.currentProject.id;
    const res = await createDepartment({ projectId, name, branchId });
    const { code, department, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('createDepartment', { branchId, department });
  },
  async updateDepartment({ commit, rootState }, { branchId, name, id }) {
    const projectId = rootState.project.currentProject.id;
    const res = await updateDepartment({ projectId, name, branchId, id });
    const { code, department, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('updateDepartment', { branchId, department });
  },
  async deleteDepartment({ commit }, { department }) {
    const { id, BranchId: branchId } = department;
    const res = await deleteDepartment({ branchId, id });
    const { code, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('deleteDepartment', { department });
  },
};

const mutations = {
  setBranches(state, { branches }) {
    state.branches = branches;
  },
  createBranch(state, { branch }) {
    state.branches = [...state.branches, branch];
  },
  updateBranch(state, { branch }) {
    const { branches } = state;
    const target = branches.find(b => b.id === branch.id);
    if (target) {
      Object.assign(target, { name: branch.name });
      state.branches = [...branches];
    }
  },
  deleteBranch(state, { branch }) {
    const { branches } = state;
    const index = branches.findIndex(b => b.id === branch.id);
    if (index > -1) {
      branches.splice(index, 1);
      state.branches = [...branches];
    }
  },
  createDepartment(state, { branchId, department }) {
    const { branches } = state;
    const targetBranch = branches.find((b) => {
      return b.id === branchId;
    });
    if (targetBranch) {
      targetBranch.Departments.push(department);
    }
  },
  updateDepartment(state, { branchId, department }) {
    const { branches } = state;
    const targetBranch = branches.find((b) => {
      return b.id === branchId;
    });
    if (targetBranch) {
      const targetDepartment = targetBranch.Departments.find((d) => {
        return d.id === department.id;
      });
      if (targetDepartment) {
        Object.assign(targetDepartment, { name: department.name });
      }
    }
  },
  deleteDepartment(state, { department }) {
    const { branches } = state;
    const { BranchId: branchId } = department;
    const targetBranch = branches.find((b) => {
      return b.id === branchId;
    });
    if (targetBranch) {
      const departments = targetBranch.Departments;

      const index = departments.findIndex((d) => {
        return d.id === department.id;
      });
      if (index > -1) {
        departments.splice(index, 1);
        targetBranch.Departments = [...departments];
      }
    }
  },
};

export default {
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

